import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Popover } from '@saucelabs/sl-component-overlay';
import { ListGroup, ListGroupItem } from '@saucelabs/sl-component-list-group';
import { constants } from '@saucelabs/sl-component-job-card';

import Styles from './PerformancePopover.styles';

const context = classNames.bind(Styles);
const { PERF_DISPLAY_OPTIONS } = constants;

const PerformancePopover = ({
  performance,
  togglePerformance,
}) => (
  performance && (
    <Popover
      id="filter-performance-popover"
      placement="bottom"
    >
      <div className={Styles.default}>
        <div className={`label ${Styles.label}`}>
          <span>View Performance By</span>
        </div>
        <ListGroup className={Styles.list}>
          {Object.entries(PERF_DISPLAY_OPTIONS).map(([key, statusItem]) => (
            <ListGroupItem
              key={key}
              className={context(
                'item',
                { active: performance.includes(statusItem.toLowerCase()) },
              )}
              onClick={() => togglePerformance(statusItem.toLowerCase())}
            >
              <span>
                {statusItem}
                {' '}
                Score
              </span>
            </ListGroupItem>
          ))}
        </ListGroup>
      </div>
    </Popover>
  )
);

PerformancePopover.propTypes = {
  performance: PropTypes.string.isRequired,
  togglePerformance: PropTypes.func.isRequired,
};

export default PerformancePopover;
